import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.76 22c-5.509 0-10-4.491-10-10s4.491-10 10-10 10 4.491 10 10-4.474 10-10 10" />
    <path
      fill="none"
      stroke="#fff"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.54}
      d="m9.583 13.022 1.21 1.21c.089.089.24.081.321-.023l3.504-4.595"
    />
  </svg>
);
export const CheckFullIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
